export const pathTypes = {
  HAPPY: 'happy path',
  UNHAPPY: 'unhappy path',
};

export type GA4RouteType = {
  page_name?: string;
  funnel_step?: number;
  step_name?: string;
  path_type?: string;
  drop_off_type?: string;
  assistance_type?: string;
};
